import * as React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import LockIcon from '@mui/icons-material/Lock';

interface PrimaryInputFieldProps {
  placeholder?: string;
  helperText?: string;
  value?: string | number;
  type?: string;
  disabled?: boolean;
  width?: string | number;
  size?: 'small' | 'medium';
  multiline?: boolean;
  rows?: number;
  maxDigits?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export default function PrimaryInputField({
  placeholder = 'Enter text',
  helperText = '',
  value = '',
  type = 'text',
  disabled = false,
  width = '25ch',
  size = 'medium',
  multiline = false,
  rows = 3,
  maxDigits,
  onChange,
}: PrimaryInputFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;

    // Enforce maxDigits for number type
    if (type === 'number' && maxDigits && newValue.length > maxDigits) {
      newValue = newValue.slice(0, maxDigits);
    }

    onChange?.({ ...event, target: { ...event.target, value: newValue } });
  };
  return (
    <FormControl sx={{ m: 1, width }} variant="outlined">
      <OutlinedInput
        id="outlined-adornment-input"
        placeholder={placeholder}
        value={value}
        type={type}
        size={size}
        disabled={disabled}
        onChange={handleChange}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        sx={{
          backgroundColor: 'white',
          textAlign: 'center',
          borderRadius: '15px',
          color: 'black',
          // enforce input text color across MUI classes and browser autofill
          '& .MuiInputBase-input': {
            color: '#000 !important',
            caretColor: '#000',
          },
          '& .MuiOutlinedInput-input': {
            color: '#000 !important',
          },
          '& input': {
            color: 'black',
            '&::placeholder': {
              color: disabled ? '#B0B0B0' : '#8e9099',
              textAlign: 'center',
              opacity: 10,
            },
          },
          '&:-webkit-autofill, & .MuiInputBase-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset !important',
            WebkitTextFillColor: '#000 !important',
          },
          '& fieldset': {
            border: 'none',
          },
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
          '& input[type=number]': {
            '-moz-appearance': 'textfield', // Firefox
          },
        }}
      />
    </FormControl>
  );
}
